var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#292D32",
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M489.739,100.174H363.885c5.702-9.832,8.984-21.231,8.984-33.391C372.87,29.959,342.911,0,306.087,0 C286.155,0,268.247,8.789,256,22.68C243.753,8.789,225.845,0,205.913,0c-36.824,0-66.783,29.959-66.783,66.783 c0,12.16,3.282,23.56,8.984,33.391H22.261c-9.22,0-16.696,7.475-16.696,16.696v100.174c0,9.22,7.475,16.696,16.696,16.696h16.696 v261.565c0,9.22,7.475,16.696,16.696,16.696h166.957h66.783h166.957c9.22,0,16.696-7.475,16.696-16.696V233.739h16.696 c9.22,0,16.696-7.475,16.696-16.696V116.87C506.435,107.649,498.96,100.174,489.739,100.174z M205.913,478.609H72.348v-244.87 h133.565V478.609z M205.913,200.348H55.652H38.957v-66.783h166.956V200.348z M205.913,100.174 c-18.412,0-33.391-14.979-33.391-33.391c0-18.412,14.979-33.391,33.391-33.391c18.412,0,33.391,14.979,33.391,33.391v33.391 h-16.696H205.913z M272.696,478.609h-33.391v-244.87h33.391V478.609z M272.696,200.348h-33.391v-66.783H256h16.696V200.348z M272.696,100.174V66.783c0-18.412,14.979-33.391,33.391-33.391c18.412,0,33.391,14.979,33.391,33.391 c0,18.412-14.979,33.391-33.391,33.391h-16.696H272.696z M439.652,478.609H306.087v-244.87h133.565V478.609z M473.043,200.348 h-16.696H306.087v-66.783h166.956V200.348z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.b76627e9e27c275aa8e0613b52766365.svg";
export { ForwardRef as ReactComponent };